"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = void 0;
var RSA_1 = __importDefault(require("./RSA"));
var TokenFormat_1 = require("./TokenFormat");
var debug_1 = __importDefault(require("./debug"));
var Timestamp_1 = require("./Timestamp");
var Telemetry_1 = require("./Telemetry");
var debug = debug_1.default.extend('TokenValidator');
var ValidationError;
(function (ValidationError) {
    ValidationError["InvalidSegmentCount"] = "InvalidSegmentCount";
    ValidationError["TypeMismatch"] = "TypeMismatch";
    ValidationError["MissingSignature"] = "MissingSignature";
    ValidationError["InvalidSignature"] = "InvalidSignature";
    ValidationError["WrongKey"] = "WrongKey";
    ValidationError["MissingPublicKey"] = "MissingPublicKey";
    ValidationError["Expired"] = "Expired";
    ValidationError["AgentCertificateRevoked"] = "AgentCertificateRevoked";
    ValidationError["ServiceCertificateRevoked"] = "ServiceCertificateRevoked";
    ValidationError["OtherCertificateRevoked"] = "OtherCertificateRevoked";
})(ValidationError || (exports.ValidationError = ValidationError = {}));
/**
 * Will do the basic verification on a token, and return the multiple parts
 * @param raw token to validate
 */
var TokenValidator = /** @class */ (function () {
    function TokenValidator(raw, segment_count, typ) {
        if (typ === void 0) { typ = null; }
        this._known_body = null;
        this.typ = typ;
        this.segment_count = segment_count;
        if (typeof raw === 'string') {
            this.segments = raw.split('.');
        }
        else {
            this.segments = raw;
        }
        this.idx = 1;
        this.header = new TokenFormat_1.Header(this.segments[0]);
    }
    Object.defineProperty(TokenValidator.prototype, "body", {
        get: function () {
            if (this._known_body) {
                return this._known_body;
            }
            return this.at_decoded(1);
        },
        enumerable: false,
        configurable: true
    });
    TokenValidator.prototype.verify_format = function (now) {
        var _this = this;
        if (now === void 0) { now = undefined; }
        var errors = [];
        if (typeof this.segment_count === 'number'
            ? this.segments.length !== this.segment_count
            : !this.segment_count(this.segments.length)) {
            errors.push(ValidationError.InvalidSegmentCount);
        }
        if (this.typ !== null &&
            !(typeof this.typ === 'string' ? [this.typ] : this.typ).reduce(function (acc, cur) { return acc || _this.header.typeMatches(cur); }, false)) {
            errors.push(ValidationError.TypeMismatch);
        }
        try {
            if (now === false) {
                // do not check
            }
            else {
                if (typeof this.body.exp !== 'undefined') {
                    if (typeof now === 'undefined' || now === true) {
                        now = (0, Timestamp_1.now)();
                    }
                    if (now > this.body.exp) {
                        errors.push(ValidationError.Expired);
                    }
                }
            }
        }
        catch (err) {
            // could either not decode, or something funky happened. dismiss it
            console.error('Error checking for expired status.. ', err);
        }
        return [errors.length === 0, errors];
    };
    TokenValidator.prototype.verify = function (pub, options) {
        return __awaiter(this, void 0, void 0, function () {
            var telemetry, _a, valid_format, errors, err_1;
            var _this = this;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        telemetry = (_b = options === null || options === void 0 ? void 0 : options.telemetry) !== null && _b !== void 0 ? _b : new Telemetry_1.Telemetry('TokenValidator verify');
                        _a = this.verify_format(options === null || options === void 0 ? void 0 : options.now), valid_format = _a[0], errors = _a[1];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 6, , 7]);
                        if (!(pub === false)) return [3 /*break*/, 2];
                        return [3 /*break*/, 5];
                    case 2:
                        if (!(typeof pub !== 'boolean')) return [3 /*break*/, 4];
                        return [4 /*yield*/, telemetry.seq('signature_matches', function (t) { return _this.signature_matches(pub, t); })];
                    case 3:
                        if (!(_c.sent())) {
                            errors.push(ValidationError.InvalidSignature);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        errors.push(ValidationError.MissingPublicKey);
                        _c.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_1 = _c.sent();
                        switch (err_1 instanceof Error ? err_1.message : err_1) {
                            case 'Key id mismatch':
                                errors.push(ValidationError.WrongKey);
                                break;
                            case 'No signature':
                                errors.push(ValidationError.MissingSignature);
                                break;
                            default:
                                // unkown error occured
                                throw err_1;
                        }
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/, [errors.length === 0, errors]];
                }
            });
        });
    };
    Object.defineProperty(TokenValidator.prototype, "remaining", {
        get: function () {
            return this.segments.length - this.idx;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenValidator.prototype, "signature", {
        get: function () {
            return this.segments[this.segments.length - 1];
        },
        enumerable: false,
        configurable: true
    });
    TokenValidator.prototype.next = function () {
        if (this.idx < this.segments.length) {
            var result = this.segments[this.idx++];
            debug({
                action: 'next',
                result: result,
                idx: this.idx,
            });
            return result;
        }
        debug({
            action: 'next',
            error: 'out of bound',
            idx: this.idx,
            seg_count: this.segments.length,
        });
        throw new Error('Out of bound');
    };
    TokenValidator.prototype.next_few = function (qty) {
        if (qty < 0) {
            var newQty = this.segments.length - this.idx + qty;
            if (newQty < 0) {
                throw new Error('Out of bound');
            }
            qty = newQty;
        }
        if (this.idx + qty <= this.segments.length) {
            var prev = this.idx;
            this.idx += qty;
            var result = this.segments.slice(prev, this.idx);
            debug({
                action: 'next_few',
                result: result,
                idx: this.idx,
                prev: prev,
                qty: qty,
            });
            return result;
        }
        debug({
            action: 'next_few',
            error: 'out of bound',
            qty: qty,
            idx: this.idx,
            seg_count: this.segments.length,
        });
        throw new Error('Out of bound');
    };
    TokenValidator.prototype.next_decoded = function (do_inflate) {
        return (0, TokenFormat_1.decode)(this.next(), do_inflate);
    };
    TokenValidator.prototype.next_is_body = function (decoded, do_inflate) {
        if (decoded === void 0) { decoded = false; }
        if (decoded) {
            return (this._known_body = this.next_decoded(do_inflate));
        }
        var part = this.next();
        this._known_body = (0, TokenFormat_1.decode)(part);
        return part;
    };
    TokenValidator.prototype.at = function (idx) {
        var fromLastIdx = null;
        if (idx < 0 && (fromLastIdx = this.segments.length + idx) >= 0 && fromLastIdx < this.segments.length) {
            return this.segments[fromLastIdx];
        }
        if (idx >= 0 && idx < this.segments.length) {
            return this.segments[idx];
        }
        throw new Error('Out of bound');
    };
    TokenValidator.prototype.at_decoded = function (idx) {
        return (0, TokenFormat_1.decode)(this.at(idx));
    };
    TokenValidator.prototype.reset = function () {
        this.idx = 1;
    };
    TokenValidator.prototype.raw = function () {
        return this.segments.join('.');
    };
    TokenValidator.prototype.signature_matches = function (pub, telemetry) {
        return __awaiter(this, void 0, void 0, function () {
            var last_seg_idx, payload, signature, rsa_verify, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        telemetry === null || telemetry === void 0 ? void 0 : telemetry.stamp('checking structure');
                        if (!('kid' in this.header) || !this.header.kid) {
                            debug('Skipping keyid check, missing header kid');
                        }
                        else if (!('keyid' in pub) || typeof pub.keyid === 'undefined' || !pub.keyid) {
                            debug('Skipping keyid check, missing pub.keyid');
                        }
                        else if (this.header.kid !== pub.keyid) {
                            debug({
                                action: 'signature_matches',
                                error: 'key id mismatch',
                                expected: this.header.kid,
                                provided: pub.keyid,
                            });
                            throw new Error('Key id mismatch');
                        }
                        if (this.segments.length < 2) {
                            debug({
                                action: 'signature_matches',
                                error: 'no signature',
                            });
                            throw new Error('No signature');
                        }
                        last_seg_idx = this.segments.length - 1;
                        payload = this.segments.slice(0, last_seg_idx).join('.');
                        signature = this.segments[last_seg_idx];
                        rsa_verify = function () { return RSA_1.default.verify(pub, payload, signature); };
                        return [4 /*yield*/, (telemetry ? telemetry.seq('rsa verify', rsa_verify) : rsa_verify())];
                    case 1:
                        result = _a.sent();
                        debug({
                            action: 'signature_matches',
                            payload: payload,
                            signature: signature,
                            pub: pub,
                            result: result,
                        });
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return TokenValidator;
}());
exports.default = TokenValidator;
